import { useState } from "react";

interface ShareButtonsProps {
  text: string;
  url: string;
  pressNumber: number;
}

export function ShareButtons({ text, url, pressNumber }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const campaignUrl = (source: string) => {
    const result = new URL(url);
    result.searchParams.set("utm_source", source);
    result.searchParams.set("utm_medium", "social");
    result.searchParams.set("utm_campaign", "press_share");
    result.searchParams.set("utm_content", `press_${pressNumber}`);
    return result.toString();
  };

  return (
    <div className="share-row" aria-label="Share this press">
      <button
        type="button"
        onClick={() => {
          void navigator.clipboard.writeText(url).then(() => {
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1_500);
          });
        }}
      >
        {copied ? "COPIED" : "COPY LINK"}
      </button>
      <a
        href={`https://x.com/intent/post?text=${encodeURIComponent(text)}&url=${encodeURIComponent(campaignUrl("x"))}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        X
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(campaignUrl("linkedin"))}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        LINKEDIN
      </a>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${text}\n\n${campaignUrl("whatsapp")}`)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        WHATSAPP
      </a>
    </div>
  );
}
